import React from "react";
import PropTypes from "prop-types";

const ItemMenuEvent = ({ link, handleClick }) => {
  const { url, title, extraClass, image, subtitle } = link;
  const ariaLabel = { "aria-label": title };
  const additionalClass = extraClass || "";
  const linkClass = `sub-link sub-link--event ${additionalClass}`;
  return (
    <a
      href={url}
      className={linkClass}
      {...ariaLabel}
      onClick={() => handleClick(title, url)}
    >
      {image && (
        <div
          className="mb-8 mb-lg-12 sub-link__event-image"
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{
            __html: image,
          }}
        />
      )}
      {subtitle && <p className="subtitle mb-4">{subtitle}</p>}
      <p className="font-600">{title}</p>
    </a>
  );
};

ItemMenuEvent.defaultProps = {
  handleClick: () => {},
};

ItemMenuEvent.propTypes = {
  link: PropTypes.object.isRequired,
  handleClick: PropTypes.func,
};

export default ItemMenuEvent;
